import { Injectable } from '@angular/core';
import { LocalStorageService } from '../Local-Storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class JwtTokenService {

  webToken = ''
  constructor(private localStorageService : LocalStorageService) { }

  setWebToken(data) {
    this.localStorageService.setWebToken(data)
  }

  getWebToken() {
    return this.localStorageService.getWebToken()
  }

  destroyWebToken() {
    this.localStorageService.destroyWebToken()
  }

}
